import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {Router} from '@angular/router';
import {PlatformLocation} from "@angular/common";
import {Constant, ContentTypeValues} from 'src/app/common/constant/constant';
import {NgbActiveModal, NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationComponent} from '../../../components/common/confirmation/confirmation.component';
import {CommonService} from '../../../services/common/common.service';
import {Subscription} from "rxjs";
import * as moment from 'moment';
import {Table} from "primeng/table";
import {RepairOrderService} from 'src/app/services/repair-order/repair-order.service';
import {ApiService} from '../../../services/api/api.service';
import {Title} from "@angular/platform-browser";
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {LandingpageService} from '../../../services/landingpage/landingpage.service';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {MediaUploadComponent} from 'src/app/components/media-upload/media-upload.component';
import {AllDataApiService} from "../../../services/all-data-api/all-data-api.service";
import {MessageService} from 'primeng/api';
import { SelectJobsListComponent } from '../select-jobs-list/select-jobs-list.component';

@Component({
  selector: 'app-ro-estimation',
  templateUrl: './ro-estimation.component.html',
  styleUrls: ['./ro-estimation.component.scss'],
  providers: [MessageService]
})
export class RoEstimationComponent implements OnInit {
  @Input() public roData;
  @Input() estimatePreviewFlag: boolean = false;
  @Input() public estimateActionFlag: boolean = false;
  @Input() viewType: string = "estimate";
  @Input() public estimateActionType: any = 'retail';
  @Input() public section: any = '';
  @ViewChild("top", { static: false }) top: ElementRef;
  @ViewChild("table", { static: false }) table: Table;
  @ViewChild('mapRef', {static: true }) mapElement: ElementRef;
  @Output() estimationReferenceEmit: EventEmitter<any> = new EventEmitter();
  @Output() roestimationActionEmit: EventEmitter<any> = new EventEmitter();
  @Output() roEstimationApproveActionEmit: EventEmitter<any> = new EventEmitter();

  public sconfig: PerfectScrollbarConfigInterface = {};
  subscription: Subscription = new Subscription();

  public bodyClass1: string = "parts-list";
  public redirectionPage='';
  public pageTitleText='';
  public apiKey: string = Constant.ApiKey;
  public fromSearch = "";
  public filterOptions: any = [];

  public assetPath: string = "assets/images/";
  public assetShopPath: string = `${this.assetPath}shop`;
  public assetPartPath: string = `${this.assetPath}parts`;
  public redirectUrl: string = "shop/view/";
  public defShopBanner: string = `${this.assetPath}common/default-shop-banner.png`;

  public editAccess: boolean;
  public displayNoRecords: boolean = false;
  public displayNoRecordsDefault: boolean = false;
  public expandFlag: boolean;
  public accessFrom: string = "";
  public shopApiCall;
  public shopWsApiCall;
  public shopType: string = "";
  public publishStatus: string = "";
  public searchVal: string = "";
  public itemLimit: any = 20;
  public itemOffset: any = 0;
  public userId;
  public user;
  public domainId;
  public roleId;
  public businessRoleId;
  public countryId='';
  public apiData: Object;

  public bodyHeight: number;
  public innerHeight: number;

  public groupId: number = 6;
  public displayNoRecordsShow = 0;
  public itemEmpty: boolean;
  public thumbView: boolean = true;
  public itemLength: number = 0;
  public itemTotal: number = 0;
  public itemList: object;
  public itemResponse = [];
  public shopSelectionList = [];
  public pinImg: string;
  public pinStatus: number;
  public likeCount: number;
  public pinCount: number;
  public pinTxt: string;
  public navAction: string = "single";
  public contentTypeValue;
  public contentTypeDefaultNewImg;
  public contentTypeDefaultNewText;
  public contentTypeDefaultNewTextDisabled: boolean = false;
  public shopUrl='';
  public newPartInfo: string = "Get started by tapping on ‘New SHOP’.";
  public chevronImg: string = `${this.assetPartPath}chevron.png`;
  public headercheckDisplay: string = "checkbox-hide";
  public headerCheck: string = "unchecked";
  public priorityIndexValue='';
  public shopIdArrayInfo: any=[];
  public shopAPICount: any="0";
  public searchnorecordflag: boolean = true;
  public searchLoading: boolean = true;
  public filterrecords : boolean = false;

  public loading: boolean = true;
  public lazyLoading: boolean = false;
  public scrollInit: number = 0;
  public lastScrollTop: number = 0;
  public scrollTop: number;
  public scrollCallback: boolean = true;
  public opacityFlag: boolean = false;
  public discount: any = 0;
  public customerDiscount: any = 0;

  repairOrderListColumns: any = [];
  repairOrderList: any = [];
  estJobUploadContents: any = [];
  saveTempData: any = [];

  detailRepairOrderList: any = [];

  estimationListArray: any = [];
  public pageAccess: string = "parts";
  public successFlag: boolean = false;
  public successMsg: string = "";

  public attachmentLoading: boolean = false;
  public uploadAction: string = "view";
  public showMap: any = false;
  public shopId: number;
  public businessName: string = '';
  public shopIndex: number;
  public updateMasonryLayout: boolean = false;
  public mapHeaderDate = '';
  public mapId = '';
  public center: google.maps.LatLngLiteral;
  public options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
  };
  mapData: any;
  mapValueData: any;
  mapHeight: any;

  public listView: boolean = true;
  public description: string = '';
  public odometerFlag: boolean = false;
  public problemDescFlag: boolean = false;
  public errroMsgFlag: boolean = false;
  public tax: number = 0;
  public taxView: number = 0;
  public totalInvoice: number = 0;
  public totalInvoiceShowOnly: any = '0';
  public totalInvoiceView: number = 0;
  public totalInvoiceViewOnly: string = '0';
  public wdTotalInvoice: any = '0';
  public diagnationDomain: boolean = false;
  public showApprovedFunc: boolean = false;

  public responseData = {
    displayNoRecords: this.displayNoRecords,
    displayNoRecordsDefault: this.displayNoRecordsDefault,
    headercheckDisplay: this.headercheckDisplay,
    headerCheck: this.headerCheck,
    itemEmpty: false,
    loading: this.loading,
    action: false,
    repairOrderList: this.repairOrderList,
    itemOffset: this.itemOffset,
    itemTotal: this.itemTotal,
    searchVal: this.searchVal,
    headerAction: false,
    filterrecords: this.filterrecords,
  };
  public modalConfig: any = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };

  public tvsDomain: boolean = false;
  public searchAction: boolean = false;
  public bodyElem;

  public repairOrderModal: boolean = false;
  public manageTitle: string = 'New Repair Order';
  serviceForm: UntypedFormGroup;
  serviceShopForm: UntypedFormGroup;
  serviceTechForm: UntypedFormGroup;
  serviceContactForm: UntypedFormGroup;
  public phoneNumberData:any;
  public icountryName = '';
  public icountryCode = '';
  public idialCode = '';
  public iphoneNumber = '';
  public phonenoInputFlag:boolean = true;
  public phoneNumberValid:boolean = false;
  public invalidNumber:boolean = true;
  public emailValidationError:boolean = false;
  public emailValidationErrorMsg = "";

  selectedCustomer: any = [];
  selectedCustomerId: any = [];
  selectedContact: any = [];
  selectedContactId: any = [];
  selectedTech: any = [];
  selectedTechId: any = [];
  regContactId: any = [];
  serviceSubmit = false;
  serviceFormValid = false;
  Time: any = [];
  Status: any = [];
  contacts: any = [];
  bussContacts: any = [];
  bussCustomers: any = [];
  Technician: any = [];
  serviceTech: any = [];
  Models: any = [];
  Makes: any = [];
  Years: any = [];
  vinIsValid = false;
  public vinVerfied = true;
  makeList: any;
  public parkingLot: boolean = false;
  public vehicleFormInfo = [];
  public vinValid = true;
  public vinDisable = false;
  public modelDisable:boolean = true;
  public modelLoading:boolean = false;
  public vinData: any = [];
  public modelPlaceHoder = "Select";
  public serviceShopSubmit:boolean = false;
  public serviceContactSubmit:boolean = false;
  public serviceTechSubmit:boolean = false;
  submitClicked = false
  formProcessing: boolean = false;
  public actionForm = '';
  public actionTitle = '';
  public actionFlag:boolean = false;
  public modalState = 'new';
  public servicetype: string = '';
  public servicetypeOptions: any = [];

  public workstreamSelection: any = [];
  public workstreamValid: boolean = true;
  public defaultWSLabel: string = 'Select Workstream';
  public workstreamName = [];
  public workstreamItems: any = [];
  public workstreamId: any = [];
  public workstream: any = [];
  public currYear: any = moment().format('Y');
  public initYear = 1960;

  public postUploadActionTrue: boolean = false;
  public postUpload: boolean = true;
  public manageAction: string;
  public postApiData: object;
  public uploadedItems: any = [];
  public commentUploadedItemsFlag: boolean = false;
  public commentUploadedItemsLength: number = 0;
  public contentType: number = 50;
  public mediaUploadItems: any = [];
  public mediaAttachments: any = [];
  public mediaAttachmentsIds: any = [];
  public displayOrder: number = 0;
  public mediaConfig: any = {backdrop: 'static', keyboard: false, centered: true, windowClass: 'attachment-modal'};
  public unit: string = '';
  public unitOptions: any = [];

  public bussContact: string = '';
  public bussCustomer: string = '';
  public contactTechnician: string = '';
  public bodyClass2: string = "submit-loader";
  public bodyClass:string = "auth-index";

  public workOrderType: string = 'new';
  public workOrderId: string = '';
  public shopExist = true;
  public existError = '';
  public viewOptions: any = [];
  public view: any = '';
  public platform: any = 3;
  displayModal = false;
  displayNote = false;
  Shops: any = [];
  public empty: any = [];
  public contactDisable: boolean = true;
  public showClear = false;
  selectedShop;
  public serviceId: number = null;
  public odo;
  public pTableHeight:any = '280px';
  public estimationView: boolean = false;
  public estimationUpdate: boolean = false;
  public productsList = [];
  public escalationMatrix_array=[];
  public publishbutton: boolean = false;
  public addnewrowbgcolor:string;
  public dragdropbgcolor: string;
  public ItemEmpty: boolean = false;
  public endUser: boolean = false;

  public jobCodeArray=[];
  public jobTitleArray=[];
  public jobDescArray=[];
  public jobqtyArray=[];
  public totalInvoice1: boolean = false;
  public totalInvoice2: boolean = false;
  public zeroVal: number = 0;
  private autoGeneratedJobs: any = [];
  enableAutoGen = false;
  loginToAllData: boolean;
  loadingAutoGenEstimates: boolean = false;

  constructor(
    private router: Router,
    private location: PlatformLocation,
    private commonApi: CommonService,
    public acticveModal: NgbActiveModal,
    private modalService: NgbModal,
    private config: NgbModalConfig,
    public apiUrl: ApiService,
    private repairOrderApi: RepairOrderService,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private LandingpagewidgetsAPI: LandingpageService,
    private authenticationService: AuthenticationService,
    private renderer: Renderer2,
    private allDataApiService: AllDataApiService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    config.size = "dialog-centered";
  }

  // convenience getters for easy access to form fields
  get sf() { return this.serviceForm.controls; }
  get stf() { return this.serviceTechForm.controls; }
  get scf() { return this.serviceContactForm.controls; }
  get shf() { return this.serviceShopForm.controls; }

  ngOnInit(): void {
    console.log(this.roData, this.viewType, this.estimateActionType);
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    this.userId = this.user.Userid;
    this.roleId = this.user.roleId;
    this.diagnationDomain = this.domainId == '338' ? true : false;
    if (!this.diagnationDomain) this.showApprovedFunc = true;
    let businessRole = localStorage.getItem('businessRole');
    this.businessRoleId = (businessRole) ? businessRole : 0;
    this.endUser = (this.roleId == 4) ? true : false;

    this.bodyElem = document.getElementsByTagName('body')[0];

    this.getROAutoGenConfig();

    if(this.roData?.customerDiscountInt && this.roData?.customerDiscountInt != undefined) {
      this.customerDiscount = this.roData.customerDiscountInt;
    }
    if(this.roData.access == 'new'){
      this.estimationView = false;
      this.estimationUpdate = true;
      this.productsList = [];
      this.escalationMatrix_array = [];
      this.itemEmpty = true;
      this.totalInvoice2 = false;
      this.totalInvoice = 0;
      this.totalInvoiceShowOnly = Math.abs(this.totalInvoice).toFixed(2);
      this.apiUrl.totalPayInvoice = this.totalInvoiceShowOnly;
      this.getRepairOrderList(false);
    }
    else if(this.roData.access == 'edit' || (this.roData.access == 'est-view' && this.estimateActionFlag)){
      this.productsList = [];
      this.escalationMatrix_array = [];
      this.getRepairOrderList(false);
      setTimeout(() => {
        this.estimationView = false;
        this.estimationUpdate = true;
        let itemArr:any = [];
        let selectedItem: any;
        if(this.roData.access == 'est-view') {
          if(this.roData.estimationData && this.viewType == 'estimate') {
            this.roData.estimationData = (this.roData.estimationDataJsonArr && this.roData.estimationDataJsonArr.length > 0) ? this.roData.estimationDataJsonArr[0] : this.roData.estimationDataJsonArr;
            let estimationData = this.roData.estimationDataJsonArr && this.roData.estimationDataJsonArr[0]?.estimationArray ? this.roData.estimationDataJsonArr[0].estimationArray : '' ;
            itemArr = estimationData;
          }
          if(this.roData.invoiceData && this.viewType == 'invoice') {
            this.roData.invoiceData = (this.roData.invoiceDataJsonArr && this.roData.invoiceDataJsonArr.length > 0) ? this.roData.invoiceDataJsonArr[0] : this.roData.invoiceDataJsonArr;
            let invoiceData = this.roData.invoiceDataJsonArr && this.roData.invoiceDataJsonArr[0]?.estimationArray ? this.roData.invoiceDataJsonArr[0].estimationArray : '' ;
            itemArr = invoiceData;
          }
          if(itemArr != '') {
            let total:any = 0;
            let wdTotal:any = 0;
            itemArr.forEach(eitem => {
              let etotal:any = (!this.showApprovedFunc || eitem?.isApproved != 0) ? parseFloat(eitem.jobtotal) : 0;
              let ewdTotal:any = (!this.showApprovedFunc || eitem?.isApproved != 0) ? parseFloat(eitem.jobWdTotal) : 0;
              total += etotal;
              wdTotal += ewdTotal;
            });
            this.totalInvoice = total;
            this.apiUrl.totalPayInvoice = this.totalInvoice;
            this.wdTotalInvoice = wdTotal;
            this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
          }
        } else {
          itemArr = this.roData.selectedItems?.estimationArray ? this.roData.selectedItems.estimationArray : '' ;
          this.totalInvoice = itemArr?.length>0 ? this.roData.selectedItems?.estimationTotal : 0;
          this.apiUrl.totalPayInvoice = this.totalInvoice;
          this.wdTotalInvoice = (this.roData.selectedItems?.wdestimationTotal && this.roData.selectedItems?.wdestimationTotal != undefined) ? this.roData.selectedItems?.wdestimationTotal : this.totalInvoice;
          this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
        }
        if(this.viewType == 'estimate') {
          this.estJobUploadContents = (this.roData?.estJobUploadContentsJsonArr && this.roData?.estJobUploadContentsJsonArr != undefined) ? this.roData.estJobUploadContentsJsonArr : [];
        } else {
          this.estJobUploadContents = (this.roData?.invoiceJobUploadContentsJsonArr && this.roData?.invoiceJobUploadContentsJsonArr != undefined) ? this.roData?.invoiceJobUploadContentsJsonArr : [];
        }
        if(this.estJobUploadContents.length == 0) {
          this.estJobUploadContents.push({uploadContents: []});
        }
        this.totalInvoiceShowOnly = Math.abs(this.totalInvoice).toFixed(2);
        this.apiUrl.totalPayInvoice = this.totalInvoiceShowOnly;
        this.wdTotalInvoice = Math.abs(this.wdTotalInvoice).toFixed(2);
        this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
        if(!this.diagnationDomain && this.estimateActionType == 'wd') {
          this.wdTotalInvoice = this.setupDiscountTotal();
          this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
        }
        this.saveTempData = itemArr?.length>0 ? itemArr : [];
        this.totalInvoice2 = itemArr?.length>0 ? true : false;
        console.log("ngOnInit productsList", this.productsList)
        if(this.totalInvoice2){
          for (let index in this.productsList){            
            let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;
            let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
            let jobDiscount = (this.productsList[index].jobDiscount && this.productsList[index].jobDiscount != undefined) ? this.productsList[index].jobDiscount : '';
            jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount : jobDiscount;
            let jobWdPrice =  (this.productsList[index].jobWdTotal && this.productsList[index].jobWdTotal != undefined) ? this.productsList[index].jobWdTotal : '0.00';
            let overwrite = this.productsList[index].jobpriceOverwrite == '1' ? this.productsList[index].jobpriceOverwrite : '0';
            let jobDuration = this.productsList[index].jobDuration;
            jobDuration = (jobDuration && jobDuration != undefined && jobDuration != null) ? this.productsList[index].jobDuration : '';
            let jobPrice = this.productsList[index].jobprice;
            let jobTotal = this.productsList[index].jobtotal;
            let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
            let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
            let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;
            if(jobDiscount == '') {
              jobDiscount = 0;
              jobWdPrice = jobTotal;
            }
            this.productsList[index].jobDiscount = jobDiscount;
            this.productsList[index].jobWdTotal = jobWdPrice;
            this.productsList[index].jobNotesEditFlag = jobNotesEditFlag;
            this.setupDiscount(this.productsList[index], index);
            this.escalationMatrix_array.push({
              id:this.productsList[index].id,
              jobId,
              qbId,
              isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
              jobcode:this.productsList[index].jobcode,
              jobtitle:this.productsList[index].jobtitle,
              jobdesc:this.productsList[index].jobdesc,
              jobDuration,
              jobprice:jobPrice,
              jobpriceShowOnly:this.productsList[index].jobpriceShowOnly,
              jobDiscount:jobDiscount,
              jobWdTotal:jobWdPrice,
              jobpriceOverwrite:overwrite,
              jobqty:this.productsList[index].jobqty,
              jobtotal:jobTotal,              
              jobNotes,
              jobMedia,
              jobNotesEditFlag,
            });
          }
          this.checkUpdateArray();
          console.log(this.escalationMatrix_array);
          if(this.roData.access == 'edit') {
            let data = {
              estimationArray: this.escalationMatrix_array,
              estimationTotal: this.totalInvoice,
              wdestimationTotal: this.wdTotalInvoice
            };
            if(this.viewType == 'estimate') {
              this.roData.estimationData = data;
              this.roData.estimationDataJsonArr = [data];
            } else {
              this.roData.invoiceData = data;
              this.roData.invoiceDataJsonArr = [data];
            }
            this.roestimationActionEmit.emit(data);
            this.estimationReferenceEmit.emit(this);
          }
        }
        let estFlag = true;
        if(!this.diagnationDomain && this.section != '' && itemArr.length == 0) {
          estFlag = false;
          let idVal = 1;
          this.itemEmpty = false;
          let prodLength = this.productsList.length;
          console.log(this.estJobUploadContents, prodLength)
          this.estJobUploadContents.push({uploadContents: []});

          //let idVal = this.productsList?.length + 1;
          let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : '0';
          // Defaly Job list push
          // this.productsList.push(
          //   { id: idVal, jobId:0, qbId:0, isApproved:1,  newmatrix: idVal, jobcode: "", jobtitle: "", jobdesc : '', jobDuration: '', jobprice : '', jobDiscount, jobWdTotal: '0.0', jobpriceOverwrite: '0', jobqty: '1.00', jobqtyShowStr: '1:00', jobtotal: '', jobNotes: '', jobMedia: [], jobEditFlag: true },
          // );
        } else {
          this.itemEmpty = itemArr.length > 0 ? false : true;
        }

        if(!this.itemEmpty && (this.section == '' || (this.section != '' && estFlag))){
          this.saveTempData = itemArr;
          this.setupData('edit');
        }
      }, 1);
    }
    else{
      let itemArr = [];
      console.log(this.roData, this.viewType);
      if(this.viewType == 'estimate' && this.roData.estimationData != ''){
        this.estimationView = true;
        this.estimationUpdate = false;
        this.detailRepairOrderList = [];
        if(this.roData.access == 'est-view') {
          this.roData.estimationData = (this.roData.estimationDataJsonArr && this.roData.estimationDataJsonArr.length > 0) ? this.roData.estimationDataJsonArr[0] : this.roData.estimationDataJsonArr;
          console.log(this.roData.estimationData)
          let estimationData = this.roData.estimationDataJsonArr && this.roData.estimationDataJsonArr[0]?.estimationArray ? this.roData.estimationDataJsonArr[0].estimationArray : '' ;
          if(this.endUser) {
             estimationData = this.roData?.customerEstimationData && this.roData?.customerEstimationData?.estimationArray ? this.roData?.customerEstimationData?.estimationArray : '';
          }
          itemArr = estimationData;
        } else {
          itemArr = this.roData.estimationData?.estimationArray ? this.roData.estimationData.estimationArray : '' ;
        }
        this.estJobUploadContents = (this.roData?.estJobUploadContentsJsonArr && this.roData?.estJobUploadContentsJsonArr != undefined) ? this.roData.estJobUploadContentsJsonArr : [];
        if(this.estJobUploadContents.length == 0) {
          this.estJobUploadContents.push({uploadContents: []});
        }
        this.loading = false;
        this.itemEmpty = false;
        this.displayNoRecords = false;
        this.itemTotal = itemArr.length;
        console.log(this.roData.estimationData, itemArr)
        if(itemArr.length>0){
          let wdTotalInvoice = 0;
          if(this.endUser) {
            this.totalInvoiceView = this.roData?.customerEstimationData?.estimationTotal ? this.roData?.customerEstimationData.estimationTotal : '' ;
            this.totalInvoiceViewOnly = Math.abs(this.roData?.customerEstimationData['estimationTotal']).toFixed(2);
            this.totalInvoiceShowOnly = this.totalInvoiceViewOnly;
            this.apiUrl.totalPayInvoice = this.totalInvoiceViewOnly;
            wdTotalInvoice = this.roData?.customerEstimationData?.wdestimationTotal ? this.roData?.customerEstimationData.wdestimationTotal : this.wdTotalInvoice;
            this.wdTotalInvoice = Math.abs(wdTotalInvoice).toFixed(2);
          } else {
            this.totalInvoiceView = this.roData.estimationData?.estimationTotal ? this.roData.estimationData.estimationTotal : '' ;
            this.totalInvoiceViewOnly = Math.abs(this.roData.estimationData['estimationTotal']).toFixed(2);
            this.totalInvoiceShowOnly = this.totalInvoiceViewOnly;
            this.apiUrl.totalPayInvoice = this.totalInvoiceViewOnly;
            wdTotalInvoice = this.roData.estimationData?.wdestimationTotal ? this.roData.estimationData.wdestimationTotal : this.wdTotalInvoice;
            this.wdTotalInvoice = Math.abs(wdTotalInvoice).toFixed(2);
          }
          
          this.apiUrl.wdTotalPayInvoice = wdTotalInvoice;
          if(!this.diagnationDomain && this.estimateActionType == 'wd') {
            this.wdTotalInvoice = this.setupDiscountTotal();
            this.apiUrl.wdTotalPayInvoice = wdTotalInvoice;
          }
        }
        if(this.totalInvoiceViewOnly == '0'){
          this.itemEmpty = true;
          this.estimationView = false;
        }
        setTimeout(() => {
          if(!this.itemEmpty){
            this.saveTempData = itemArr;
            this.setupData('view');
          }
        }, 1);
      } else if(this.viewType == 'invoice' && this.roData.invoiceData != ''){
        this.estimationView = true;
        this.estimationUpdate = false;
        this.detailRepairOrderList = [];
        if(this.roData.access == 'est-view') {
          this.roData.invoiceData = (this.roData.invoiceDataJsonArr && this.roData.invoiceDataJsonArr.length > 0) ? this.roData.invoiceDataJsonArr[0] : this.roData.invoiceDataJsonArr;
          console.log(this.roData.invoiceData)
          let estimationData = this.roData.invoiceDataJsonArr && this.roData.invoiceDataJsonArr[0]?.estimationArray ? this.roData.invoiceDataJsonArr[0].estimationArray : '' ;
          itemArr = estimationData;
        } else {
          itemArr = this.roData.invoiceData?.estimationArray ? this.roData.invoiceData.estimationArray : '' ;
        }
        this.estJobUploadContents = (this.roData?.invoiceJobUploadContentsJsonArr && this.roData?.invoiceJobUploadContentsJsonArr != undefined) ? this.roData?.invoiceJobUploadContentsJsonArr : [];
        if(this.estJobUploadContents.length == 0) {
          this.estJobUploadContents.push({uploadContents: []});
        }
        this.loading = false;
        this.itemEmpty = false;
        this.displayNoRecords = false;
        this.itemTotal = itemArr.length;
        console.log(this.roData.estimationData, itemArr)
        if(itemArr.length>0){
          this.totalInvoiceView = this.roData.invoiceData?.estimationTotal ? this.roData.invoiceData.estimationTotal : '' ;
          this.totalInvoiceViewOnly = Math.abs(this.roData.invoiceData['estimationTotal']).toFixed(2);
          this.apiUrl.totalPayInvoice = this.totalInvoiceViewOnly;
          let wdTotalInvoice = this.roData.invoiceData?.wdestimationTotal ? this.roData.invoiceData.wdestimationTotal : this.wdTotalInvoice;
          this.wdTotalInvoice = Math.abs(wdTotalInvoice).toFixed(2);
          this.apiUrl.wdTotalPayInvoice = wdTotalInvoice;
          if(!this.diagnationDomain && this.estimateActionType == 'wd') {
            this.wdTotalInvoice = this.setupDiscountTotal();
            this.apiUrl.wdTotalPayInvoice = wdTotalInvoice;
          }
        }
        if(this.totalInvoiceViewOnly == '0'){
          this.itemEmpty = true;
          this.estimationView = false;
        }
        setTimeout(() => {
          if(!this.itemEmpty){
            this.saveTempData = itemArr;
            this.setupData('view');
          }
        }, 1);
      } else {
        this.estimationView = false;
        this.itemEmpty = true;
      }
    }

    for (let y = 1; y < 11; y++) {
      this.jobqtyArray.push(y);
    }

    this.servicetype = "Tech Support";
    this.servicetypeOptions = ["Tech Support" ,"remote"];

    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();
    console.log(this.bodyHeight)
    this.setupHeaderColumn();
    setTimeout(() => {
      this.estimationReferenceEmit.emit(this);
    }, 500);
  }

  private getROAutoGenConfig() {
    if (this.roData?.adasReportIdInt > 0) {
      this.loading = true;
      console.log(this.roData);
      const apiFormData = {
        apiKey: this.apiKey,
        domainId: this.domainId,
        userId: this.userId,
        reportId: this.roData.adasReportIdInt
      };
      this.allDataApiService.getRoAutoGenConfig(apiFormData).subscribe((response) => {
        this.loading = false;
        if (response?.data?.enableAutoGen != undefined) {
          this.enableAutoGen = response?.data?.enableAutoGen;
        }
      });
    }
  }

  setupHeaderColumn() {
    //let wdColumnClass = (this.diagnationDomain || this.estimateActionType == 'retail') ? 'hide' : '';
    let totalTitle = (this.diagnationDomain || this.estimateActionType == 'retail') ? 'Total' : 'WD Total';
    let qtyVisible = (this.diagnationDomain) ? '' : 'hide';
    this.repairOrderListColumns = [
      {field: 'id', columnName: 'id', header: 'Job', headerId: "1", inputType: "1", columnpredefind: "1", columnpclass: 'header ro-ta-col-1 col-sticky'},
      {field: 'jobcode', columnName: 'jobcode', header: 'Job Code', headerId: "2", columnpredefind: "1", inputType: "8", columnpclass: 'header ro-ta-col-2'},
      {field: 'jobtitle', columnName: 'jobtitle', header: 'Job Title', headerId: "3", columnpredefind: "1", inputType: "8", columnpclass: 'header ro-ta-col-3'},
      {field: 'jobdesc', columnName: 'jobdesc', header: 'Job Description', headerId: "4", columnpredefind: "1", inputType: "8", columnpclass: 'header ro-ta-col-4'},
      {field: 'jobprice', columnName: 'jobprice', header: 'Unit Price', headerId: "5", columnpredefind: "1", inputType: "5", columnpclass: 'header ro-ta-col-5 price'},
      {field: 'jobqty', columnName: 'jobqty', header: 'Qty', headerId: "6", inputType: "5", columnpredefind: "1", columnpclass: `header ro-ta-col-6`},
      {field: 'jobDiscount', columnName: 'jobDiscount', header: 'Discount', headerId: "6", inputType: "6", columnpredefind: "1", columnpclass: `header ro-ta-col-6 discount`},
      {field: 'jobtotal', columnName: 'jobtotal', header: totalTitle, headerId: "7", inputType: "7", columnpredefind: "1", columnpclass: 'header ro-ta-col-7'},
    ];
  }

  setupData(type){

    if(type == 'edit'){
      this.productsList = [];
    }
    else{
      this.detailRepairOrderList=[];
    }

    let resultData = this.saveTempData;
    console.log(this.saveTempData)
    if(resultData.length>0){
      for(let item in resultData){
        resultData[item].qbId = (resultData[item].qbId && resultData[item].qbId != undefined) ? resultData[item].qbId : 0;
        resultData[item].jobId = (resultData[item].jobId && resultData[item].jobId != undefined) ? resultData[item].jobId : 0;
        resultData[item].jobcode = resultData[item].jobcode;
        resultData[item].jobtitle = resultData[item].jobtitle;
        resultData[item].jobdesc = resultData[item].jobdesc;
        resultData[item].jobprice = resultData[item].jobprice;
        resultData[item].jobtotal = resultData[item].jobtotal;
        // resultData[item].isApproved = (resultData[item]?.isApproved != 0 ) ? true : false;

        let overwrite = resultData[item].jobpriceOverwrite == '1' ? resultData[item].jobpriceOverwrite : '0';
        resultData[item].jobpriceOverwrite = overwrite;
        resultData[item].jobqtyShowStr = Number(resultData[item].jobqty).toFixed(2);
        resultData[item].jobpriceShowStr = Number(resultData[item].jobprice).toFixed(2);
        resultData[item].jobpriceShowOnly = Math.abs(resultData[item].jobprice).toFixed(2);
        resultData[item].jobtotalShowStr = Number(resultData[item].jobtotal).toFixed(2);
        resultData[item].jobtotalShowOnly = Math.abs(resultData[item].jobtotal).toFixed(2);

        resultData[item].jobNotes = (resultData[item].jobNotes && resultData[item].jobNotes != undefined) ? resultData[item].jobNotes : '';
        resultData[item].jobMedia = (resultData[item].jobMedia && resultData[item].jobMedia != undefined) ? resultData[item].jobMedia : [];
        resultData[item].jobNotesEditFlag = (resultData[item].jobNotes != '' || resultData[item].jobMedia.length > 0) ? true : false;
        let jobDuration = (resultData[item].jobDuration && resultData[item].jobDuration != undefined && resultData[item].jobDuration != null) ? resultData[item].jobDuration : '';
        let jobDiscount = (resultData[item].jobDiscount && resultData[item].jobDiscount != undefined) ? resultData[item].jobDiscount : '';
        jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount : jobDiscount;
        let jobWdPrice =  (resultData[item].jobWdTotal && resultData[item].jobWdTotal != undefined) ? resultData[item].jobWdTotal : '0.00';
        let jobTotal = resultData[item].jobtotal;
        let jobNotes = (resultData[item].jobNotes && resultData[item].jobNotes != undefined) ? resultData[item].jobNotes : '';
        let jobMedia = (resultData[item].jobMedia && resultData[item].jobMedia != undefined) ? resultData[item].jobMedia : [];
        let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;

        if(jobDiscount == '') {
          jobDiscount = 0;
          //let wdPrice = jobTotal*(jobDiscount/100);
          //wdPrice = jobTotal-wdPrice;
          //jobWdPrice = (Math.abs(wdPrice)).toFixed(2);
          jobWdPrice = jobTotal;
        }
        resultData[item].jobDiscount = jobDiscount;
        resultData[item].jobWdTotal = this.setupDiscount(resultData[item]);
        resultData[item].jobNotes = jobNotes;
        resultData[item].jobMedia = jobMedia;
        resultData[item]['jobDuration'] = jobDuration;
        resultData[item].jobNotesEditFlag = jobNotesEditFlag;

        if(type == 'edit'){
          this.productsList.push(resultData[item]);
        }
        else{
          this.detailRepairOrderList.push(resultData[item]);
        }
      }
      /* if(this.estimatePreviewFlag) {
        setTimeout(() => {
          this.setupJobViewHeight();
        }, 1500);
      } */
    }
    console.log(this.productsList)
    console.log(this.detailRepairOrderList)

    if(type == 'edit'){
      if(this.totalInvoice2){
        if(this.productsList.length>0){
          for (let index in this.productsList){
            let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;
            let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
            let overwrite = this.productsList[index].jobpriceOverwrite == '1' ? this.productsList[index].jobpriceOverwrite : '0';
            let jobDiscount = (this.productsList[index].jobDiscount && this.productsList[index].jobDiscount != undefined) ? this.productsList[index].jobDiscount : '';
            jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount : jobDiscount;
            let jobDuration = (this.productsList[index].jobDuration && this.productsList[index].jobDuration != undefined && this.productsList[index].jobDuration != null) ? this.productsList[index].jobDuration : '';
            let jobWdPrice =  (this.productsList[index].jobWdTotal && this.productsList[index].jobWdTotal != undefined) ? this.productsList[index].jobWdTotal : '0.00';
            let jobTotal = this.productsList[index].jobtotal;
            let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
            let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
            let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;

            if(jobDiscount == '') {
              jobDiscount = 0;
              jobWdPrice = jobTotal;
            }
            this.productsList[index].jobDiscount = jobDiscount;
            this.productsList[index].jobWdTotal = jobWdPrice;
            this.productsList[index].jobNotesEditFlag = jobNotesEditFlag;
            this.productsList[index].jobDuration = jobDuration;
            this.setupDiscount(this.productsList[index], index);

            this.escalationMatrix_array.push({
              id:this.productsList[index].id,
              jobId,
              qbId,
              isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
              jobcode:this.productsList[index].jobcode,
              jobtitle:this.productsList[index].jobtitle,
              jobdesc:this.productsList[index].jobdesc,
              jobprice:this.productsList[index].jobprice,
              jobDiscount:jobDiscount,
              jobWdTotal:this.productsList[index].jobWdTotal,
              jobpriceShowStr:this.productsList[index].jobpriceShowStr,
              jobpriceShowOnly:this.productsList[index].jobpriceShowOnly,
              jobpriceOverwrite:overwrite,
              jobqty:this.productsList[index].jobqty,
              jobqtyShowStr:this.productsList[index].jobqtyShowStr,
              jobtotal:this.productsList[index].jobtotal,
              jobtotalShowStr:this.productsList[index].jobtotalShowStr,
              jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
              jobDuration,
              jobNotes,
              jobMedia,
              jobNotesEditFlag,
            });
          }
        }
        this.checkUpdateArray();
        console.log(this.escalationMatrix_array);
        if(this.roData.access == 'edit') {
          let data = {
            estimationArray: this.escalationMatrix_array,
            estimationTotal: this.totalInvoice,
            wdestimationTotal: this.wdTotalInvoice
          };
          if(this.viewType == 'estimate') {
            this.roData.estimationData = data;
            this.roData.estimationDataJsonArr = [data];
          } else {
            this.roData.invoiceData = data;
            this.roData.invoiceDataJsonArr = [data];
          }
          this.roestimationActionEmit.emit(data);
          this.estimationReferenceEmit.emit(this);
        }
      }
      if(this.roData.access == 'est-view' && this.estimationUpdate) {
        setTimeout(() => {
          //this.setupRowHeight();
        }, 1500);
      }
    }
  }

  // Get SHOP List
  getRepairOrderList(pushFlag,limit:any = '') {
    this.scrollTop = 0;
    this.lastScrollTop = this.scrollTop;
    let formData = new FormData();
    formData.append('apiKey', this.apiKey);
    formData.append('domainId', this.domainId);
    formData.append('contentTypeId', ContentTypeValues.RepairOrder);
    //formData.append('limit', this.itemLimit);
    //formData.append('offset', this.itemOffset);
    if(this.estimationUpdate){
      formData.append('fromRepairOrderPage', '1');
      formData.append('make', this.roData.make);
      formData.append('model', this.roData.model);
    }
    else{
      formData.append('workOrderId', this.roData.id );
    }

    formData.append('fromWorkOrder', '1' );

    this.loading = true;
    this.lazyLoading = this.loading;
    this.repairOrderApi.getJOBDetailsList(formData).subscribe(response => {
      console.log("getJOBDetailsList: ", response);
      let resultData = [];

      response = response.data;
      resultData = response.items;


      this.itemTotal = response.total;
      this.loading = false;
      this.lazyLoading = this.loading;

      this.jobCodeArray=[];
      this.jobTitleArray=[];
      this.jobDescArray=[];
      this.repairOrderList =[];

      if(this.itemOffset == 0) {
        this.discount = response.discount;
      }

      if(this.itemTotal>0){
        if(resultData.length>0){

          for(let item in resultData){
            let overwrite = resultData[item].jobpriceOverwrite == '1' ? resultData[item].jobpriceOverwrite : '0';
            resultData[item].jobId = resultData[item].jobId;
            resultData[item].qbId = resultData[item].qbId;
            resultData[item].jobcode = resultData[item].jobCode;
            resultData[item].jobtitle = resultData[item].title;
            resultData[item].jobdesc = resultData[item].description;
            resultData[item].jobprice = resultData[item].unitPrice;
            resultData[item].jobDuration = resultData[item].jobDuration;
            resultData[item].jobpriceOverwrite = overwrite;
            resultData[item].jobtotal = resultData[item].jobtotal;

            let jobqty = parseFloat(resultData[item].jobqty) > 0 ? resultData[item].jobqty : '1.00';

            resultData[item].jobqty = Number(jobqty).toFixed(2);
            resultData[item].jobqtyShowStr = Number(jobqty).toFixed(2);

            if(resultData[item].unitPrice != '' && resultData[item].unitPrice != '-' && resultData[item].unitPrice != 0){
              resultData[item].jobprice = Number(resultData[item].unitPrice).toFixed(2);
              resultData[item].jobpriceShowOnly = (Math.abs(resultData[item].unitPrice)).toFixed(2);
            }
            else{
              resultData[item].jobprice = '';
              resultData[item].jobpriceShowOnly =  '';
            }

            if(resultData[item].jobtotal != '' && resultData[item].jobtotal != '-' && resultData[item].jobtotal != 0){
              resultData[item].jobtotal = Number(resultData[item].jobtotal).toFixed(2);
              resultData[item].jobtotalShowOnly = (Math.abs(resultData[item].jobtotal)).toFixed(2);
            }
            else{
              resultData[item].jobtotal = '';
              resultData[item].jobtotalShowOnly =  '';
            }

            let jobNotes = (resultData[item].jobNotes && resultData[item].jobNotes != undefined) ? resultData[item].jobNotes : '';
            let jobMedia = (resultData[item].jobMedia && resultData[item].jobMedia != undefined) ? resultData[item].jobMedia : [];
            let jobNotesEditFlag = (resultData[item].jobNotes != '' || resultData[item].jobMedia.length > 0) ? true : false;;

            resultData[item].jobNotes = jobNotes;
            resultData[item].jobMedia = jobMedia;
            resultData[item].jobNotesEditFlag = jobNotesEditFlag;

            this.jobCodeArray.push({
              name : resultData[item].jobcode
            });
            this.jobTitleArray.push({
              name:resultData[item].jobtitle
            });
            this.jobDescArray.push({
              name:resultData[item].jobdesc
            });

            this.repairOrderList.push(resultData[item]);

          }

          console.log("getJOBDetailsList productsList", this.productsList)
          this.checkUpdateArray();

        }
      }
      else{
        this.itemEmpty = true;
      }


    });
  }

  // Set Screen Height
  setScreenHeight() {
    this.innerHeight = 0;
    this.innerHeight = 1000;
  }

  addjobNew(){
    this.onChangeSelection('jobCode')
  }
  
  addjob(){
    if(this.productsList?.length>0){
      this.addnewrowbgcolor='addnewrow';
      /*if(this.escalationMatrix_array.length == 0){
        this.addnewrowbgcolor='addnewrowerror';
        return false;
      } */

      if(this.productsList.length>0)
      {
        for (let wsd in this.productsList)
        {
          console.log(this.productsList[wsd]);
          if(this.productsList[wsd].jobqty=='' || this.productsList[wsd].jobprice==''){
            this.addnewrowbgcolor='addnewrowerror';
           // return false;
          }
        }
      }

    }
    /*if(this.productsList?.length==0){
      this.itemEmpty = false;
      let idVal = this.productsList?.length + 1;
      this.productsList.push(
        { id: idVal, newmatrix: idVal, jobcode: "", jobtitle: "", jobdesc : '', jobprice : '', jobqty: 1, jobtotal: '' },
      );
    }
    else{ */
      let idVal = 1;
      this.itemEmpty = false;
      if(this.productsList){
        if(this.productsList?.length>1){
          let lastIdVal = this.productsList[this.productsList.length - 1].id;
          console.log(lastIdVal);
          idVal = lastIdVal + 1;
        }
        else if(this.productsList?.length==1){
          let lastIdVal = this.productsList[0].id;
          idVal = lastIdVal + 1;
        }
        else{
          idVal = 1;
        }
      }
      let prodLength = this.productsList.length;
      console.log('Estimate Media:', this.estJobUploadContents, 'Invoice Media', this.estJobUploadContents, prodLength)
      this.estJobUploadContents.push({uploadContents: []});

      //let idVal = this.productsList?.length + 1;
      let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : '0';
      this.productsList.push(
        { id: idVal, jobId: 0, qbId: 0, isApproved: 1, newmatrix: idVal, jobcode: "", jobtitle: "", jobdesc : '', jobDuration: '', jobprice : '', jobDiscount, jobWdTotal: '0.0', jobpriceOverwrite: '0', jobqty: '1.00', jobqtyShowStr: '1:00', jobtotal: '', jobNotes: '', jobMedia: [], jobEditFlag: true },
      );
    //}

    console.log(this.productsList)

  }


  deleteAction(index){

    console.log(this.escalationMatrix_array);
    console.log(this.productsList);

    //remove all if index == ALL
    if (index == 'ALL') {
      this.productsList = [];
      this.escalationMatrix_array = [];
      this.itemEmpty = true;
      this.totalInvoice2 = false;
      this.totalInvoice = 0;
      this.totalInvoiceShowOnly = '0';
      this.apiUrl.totalPayInvoice = this.totalInvoiceShowOnly;
      this.wdTotalInvoice = '0';
      this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
      return false;
    } else {
      if(!this.diagnationDomain) {
        let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;
        if(jobId != 0) {
          let jobIndex = this.roData.jobItemsInfoJsonArr.findIndex(option => parseInt(option.id) == parseInt(jobId));
          if(jobIndex >= 0) {
            this.roData.jobItemsInfoJsonArr.splice(jobIndex, 1);
            this.roData.jobItemsIntArr.splice(jobIndex, 1);
          }
        }
      }
      this.productsList.splice(index, 1);
    }
    if(this.productsList?.length>0){
      this.escalationMatrix_array = [];
      for (let index1 in this.productsList) {
        let overwrite = this.productsList[index1].jobpriceOverwrite == '1' ? this.productsList[index1].jobpriceOverwrite : '0';
        let jobId = (this.productsList[index1].jobId && this.productsList[index1].jobId != undefined) ? this.productsList[index1].jobId : 0            
        let qbId = (this.productsList[index1].qbId && this.productsList[index1].qbId != undefined) ? this.productsList[index1].qbId : 0;
        let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index1].jobDiscount;
        let jobNotes = (this.productsList[index1].jobNotes && this.productsList[index1].jobNotes != undefined) ? this.productsList[index1].jobNotes : '';
        let jobMedia = (this.productsList[index1].jobMedia && this.productsList[index1].jobMedia != undefined) ? this.productsList[index1].jobMedia : [];
        let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;

        this.setupDiscount(this.productsList[index1], index1);
        this.escalationMatrix_array.push({
          id:this.productsList[index1].id,
          jobId,
          qbId,
          isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
          jobcode:this.productsList[index1].jobcode,
          jobtitle:this.productsList[index1].jobtitle,
          jobdesc:this.productsList[index1].jobdesc,
          jobDuration:this.productsList[index1].jobDuration,
          jobprice:this.productsList[index1].jobprice,
          jobpriceShowOnly:Math.abs(this.productsList[index1].jobprice),
          jobpriceOverwrite:overwrite,
          jobDiscount,
          jobWdTotal:this.productsList[index1].jobWdTotal,
          jobqty:this.productsList[index1].jobqty,
          jobtotal:this.productsList[index1].jobtotal,
          jobtotalShowOnly:Math.abs(this.productsList[index1].jobtotal),
          jobNotes,
          jobMedia,
          jobNotesEditFlag,
        });
      }
    } else {
      this.escalationMatrix_array = [];
    }

    console.log(this.escalationMatrix_array);
    console.log(this.productsList);

    if(this.productsList?.length==0){
      this.itemEmpty = true;
      this.totalInvoice2 = false;
      this.totalInvoice = 0;
      this.totalInvoiceShowOnly = '0';
      this.apiUrl.totalPayInvoice = this.totalInvoiceShowOnly;
      this.wdTotalInvoice = '0';
      this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
    }
    this.calculateAmt();

  }

  collectionHas(a, b) { //helper function (see below)
    for (let i = 0, len = a.length; i < len; i ++) {
        if(a[i] == b) return true;
    }
    return false;
  }
  findParentBySelector(elm, selector) {
    var all = document.querySelectorAll(selector);
    var cur = elm.parentNode;
    while(cur && !this.collectionHas(all, cur)) { //keep going up until you find a match
        cur = cur.parentNode; //go up
    }
    return cur; //will return null if not found
  }

  setItemArray(value)
  {

    return value.map(e => e.name).join(", ");

  }
  setItemSpace(value)
  {

    return value.map(e => e).join(", ");

  }
  onChangeOption(event, productsLis, hId, colName,index='') {
    console.log('onChangeOption event : ', event);
    console.log('onChangeOption productsLis : ' , productsLis);
    console.log('onChangeOption item : ', this.productsList[index]);
    console.log('onChangeOption hId : ', hId);
    console.log('onChangeOption colName : ', colName);
    console.log('onChangeOption index : ', index);

    setTimeout(() => {
      // close the cell editor after selection
      const bodyElement = document.body;
      bodyElement?.click();
    }, 50);
    
setTimeout(() => {


    switch(colName){
      case 'jobcode':
        for(let rolist in this.repairOrderList) {
          if(this.repairOrderList[rolist].jobcode == productsLis.jobcode) {
            console.log(this.repairOrderList[rolist])
            let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.repairOrderList[rolist].discountPrice;
            this.productsList[index].jobId = this.repairOrderList[rolist].id;
            this.productsList[index].qbId = this.repairOrderList[rolist].qbId;
            this.productsList[index].jobtitle = this.repairOrderList[rolist].jobtitle;
            this.productsList[index].jobdesc = this.repairOrderList[rolist].jobdesc;
            this.productsList[index].jobDuration = this.repairOrderList[rolist].jobDuration;
            this.productsList[index].jobprice = this.repairOrderList[rolist].jobprice == '' ? 0 : parseFloat(this.repairOrderList[rolist].jobprice);
            this.productsList[index].jobqty =  parseFloat(this.repairOrderList[rolist].jobqty);
            this.productsList[index].jobtotal = (this.productsList[index].jobqty) * (this.productsList[index].jobprice);
            this.productsList[index].jobDiscount = jobDiscount;
            this.productsList[index].jobWdTotal = this.setupDiscount(this.repairOrderList[rolist]);
            this.productsList[index].jobNotes = (this.repairOrderList[index].jobNotes && this.repairOrderList[index].jobNotes != undefined) ? this.repairOrderList[index].jobNotes : '';
            this.productsList[index].jobMedia = (this.repairOrderList[index].jobMedia && this.repairOrderList[index].jobMedia != undefined) ? this.repairOrderList[index].jobMedia : [];
            this.productsList[index].jobNotesEditFlag = (this.repairOrderList[index].jobNotes != '' || this.repairOrderList[index].jobMedia.length > 0) ? true : false;
          }
        }
        break;
      case 'jobdesc':
          for(let rolist in this.repairOrderList) {
            if(this.repairOrderList[rolist].jobdesc == productsLis.jobdesc) {
              let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.repairOrderList[rolist].discountPrice;
              this.productsList[index].jobId = this.repairOrderList[rolist].id;
              this.productsList[index].qbId = this.repairOrderList[rolist].qbId;
              this.productsList[index].jobtitle = this.repairOrderList[rolist].jobtitle;
              this.productsList[index].jobDuration = this.repairOrderList[rolist].jobDuration;
              this.productsList[index].jobcode = this.repairOrderList[rolist].jobcode;
              this.productsList[index].jobprice = this.repairOrderList[rolist].jobprice == '' ? 0 : parseFloat(this.repairOrderList[rolist].jobprice);
              this.productsList[index].jobqty =  parseFloat(this.repairOrderList[rolist].jobqty);
              this.productsList[index].jobtotal = (this.productsList[index].jobqty) * (this.productsList[index].jobprice);
              this.productsList[index].jobDiscount = jobDiscount;
              this.productsList[index].jobWdTotal = this.setupDiscount(this.repairOrderList[rolist]);
              this.productsList[index].jobNotes = (this.repairOrderList[index].jobNotes && this.repairOrderList[index].jobNotes != undefined) ? this.repairOrderList[index].jobNotes : '';
              this.productsList[index].jobMedia = (this.repairOrderList[index].jobMedia && this.repairOrderList[index].jobMedia != undefined) ? this.repairOrderList[index].jobMedia : [];
              this.productsList[index].jobNotesEditFlag = (this.repairOrderList[index].jobNotes != '' || this.repairOrderList[index].jobMedia.length > 0) ? true : false;
            }
          }
          break;
        case 'jobtitle':
            for(let rolist in this.repairOrderList) {
              if(this.repairOrderList[rolist].jobtitle == productsLis.jobtitle) {
                let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.repairOrderList[rolist].discountPrice;
                this.productsList[index].jobId = this.repairOrderList[rolist].id;
                this.productsList[index].qbId = this.repairOrderList[rolist].qbId;
                this.productsList[index].jobcode = this.repairOrderList[rolist].jobcode;
                this.productsList[index].jobdesc = this.repairOrderList[rolist].jobdesc;
                this.productsList[index].jobDuration = this.repairOrderList[rolist].jobDuration;
                this.productsList[index].jobprice = this.repairOrderList[rolist].jobprice == '' ? 0 : parseFloat(this.repairOrderList[rolist].jobprice);
                this.productsList[index].jobqty =  parseFloat(this.repairOrderList[rolist].jobqty);
                this.productsList[index].jobtotal = (this.productsList[index].jobqty) * (this.productsList[index].jobprice);
                this.productsList[index].jobDiscount = jobDiscount;
                this.productsList[index].jobWdTotal = this.setupDiscount(this.repairOrderList[rolist]);
                this.productsList[index].jobNotes = (this.repairOrderList[index].jobNotes && this.repairOrderList[index].jobNotes != undefined) ? this.repairOrderList[index].jobNotes : '';
                this.productsList[index].jobMedia = (this.repairOrderList[index].jobMedia && this.repairOrderList[index].jobMedia != undefined) ? this.repairOrderList[index].jobMedia : [];
                this.productsList[index].jobNotesEditFlag = (this.repairOrderList[index].jobNotes != '' || this.repairOrderList[index].jobMedia.length > 0) ? true : false;
              }
            }
            break;

    }

    this.productsList[index].jobqtyShowStr = Number(this.productsList[index].jobqty).toFixed(2);
    this.productsList[index].jobpriceShowStr = Number(this.productsList[index].jobprice).toFixed(2);
    this.productsList[index].jobpriceShowOnly = Math.abs(this.productsList[index].jobprice).toFixed(2);
    this.productsList[index].jobtotalShowStr = Number(this.productsList[index].jobtotal).toFixed(2);
    this.productsList[index].jobtotalShowOnly = Math.abs(this.productsList[index].jobtotal).toFixed(2);
    this.productsList[index].jobWdTotal = Math.abs(this.productsList[index].jobWdTotal).toFixed(2);

    console.log(productsLis);
    console.log(this.productsList[index]);


      if(this.escalationMatrix_array.length>0)
      {
        for (let wsd in this.escalationMatrix_array)
        {
          let studentObj =  this.escalationMatrix_array.find(t=>t.id==productsLis.id);
          if(studentObj)
          {
            if(colName=='jobcode' || colName=='jobtitle' || colName=='jobdesc')
            {
              let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index].jobDiscount;
              this.setupDiscount(this.productsList[index], index);
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobId = this.productsList[index].jobId;  
              this.escalationMatrix_array.find(item => item.id == productsLis.id).qbId = this.productsList[index].qbId;  
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobcode = this.productsList[index].jobcode;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtitle = this.productsList[index].jobtitle;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobdesc = this.productsList[index].jobdesc;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobDuration = this.productsList[index].jobDuration;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobprice = this.productsList[index].jobpriceShowStr;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobpriceShowOnly = this.productsList[index].jobpriceShowOnly;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobqty = this.productsList[index].jobqtyShowStr;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotal = this.productsList[index].jobtotalShowStr;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowStr = this.productsList[index].jobtotalShowStr;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowOnly = this.productsList[index].jobtotalShowOnly;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobDiscount = jobDiscount;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobWdTotal = this.productsList[index].jobWdTotal;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobNotes = this.productsList[index].jobNotes;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobMedia = this.productsList[index].jobMedia;
              this.escalationMatrix_array.find(item => item.id == productsLis.id).jobNotesEditFlag = this.productsList[index].jobNotesEditFlag;
            }
          }
          else
          {
            let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index].jobDiscount;
            this.setupDiscount(this.productsList[index], index);
            let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;              
            let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
            let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
            let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
            let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;
            this.escalationMatrix_array.push({
              id:productsLis.id,
              jobId,
              qbId,
              isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
              jobcode:this.productsList[index].jobcode,
              jobtitle:this.productsList[index].jobtitle,
              jobdesc:this.productsList[index].jobdesc,
              jobDuration:this.productsList[index].jobDuration,
              jobprice:this.productsList[index].jobpriceShowStr,
              jobpriceShowOnly:Math.abs(this.productsList[index].jobprice).toFixed(2),
              jobpriceOverwrite:this.productsList[index].jobpriceOverwrite,
              jobDiscount,
              jobWdTotal:this.productsList[index].jobWdTotal,
              jobqty:this.productsList[index].jobqtyShowStr,
              jobtotal:this.productsList[index].jobtotalShowStr,
              jobtotalShowStr:this.productsList[index].jobtotalShowStr,
              jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
              jobNotes,
              jobMedia,
              jobNotesEditFlag,
            });
          }
        }
      }
      else
      {
        let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index].jobDiscount;
        this.setupDiscount(this.productsList[index], index);
        let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;              
        let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
        let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
        let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
        let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;
        this.escalationMatrix_array.push({
          id:productsLis.id,
          jobId,
          qbId,
          isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
          jobcode:this.productsList[index].jobcode,
          jobtitle:this.productsList[index].jobtitle,
          jobdesc:this.productsList[index].jobdesc,
          jobDuration:this.productsList[index].jobDuration,
          jobprice:this.productsList[index].jobpriceShowStr,
          jobpriceShowOnly:Math.abs(this.productsList[index].jobprice).toFixed(2),
          jobpriceOverwrite:this.productsList[index].jobpriceOverwrite,
          jobDiscount,
          jobWdTotal:this.productsList[index].jobWdTotal,
          jobqty:this.productsList[index].jobqtyShowStr,
          jobtotal:this.productsList[index].jobtotalShowStr,
          jobtotalShowStr:this.productsList[index].jobtotalShowStr,
          jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
          jobNotes,
          jobMedia,
          jobNotesEditFlag,
        });
      }
      setTimeout(() => {
        console.log(this.escalationMatrix_array);
        this.calculateAmt();
      }, 100);

   }, 100);
  }

  checkUpdateArray(){
    this.jobCodeArray=[];
    this.jobTitleArray=[];
    this.jobDescArray=[];
    for(let item in this.repairOrderList){
      this.jobCodeArray.push({
        name:this.repairOrderList[item].jobcode
      });
      this.jobTitleArray.push({
        name : this.repairOrderList[item].jobtitle
      });
      this.jobDescArray.push({
        name : this.repairOrderList[item].jobdesc
      });
    }

    for(let rolist in this.escalationMatrix_array) {
      if(this.productsList.length>0)
      {
        for (let wsd in this.productsList)
        {
          if(this.escalationMatrix_array[rolist].jobcode == this.productsList[wsd].jobcode) {

            let index1 = this.jobCodeArray.findIndex(option => option.name == this.productsList[wsd].jobcode);
            if(index1 >= 0 ){
              this.jobCodeArray.splice(index1, 1);
            }

            let index2 = this.jobTitleArray.findIndex(option => option.name == this.productsList[wsd].jobtitle);
            if(index2 >= 0 ){
              this.jobTitleArray.splice(index2, 1);
            }

            let index3 = this.jobDescArray.findIndex(option => option.name == this.productsList[wsd].jobdesc);
            if(index3 >= 0 ){
              this.jobDescArray.splice(index3, 1);
            }

          }
        }
      }
    }

    //console.log(this.jobCodeArray);

  }
  calculateAmt(){
    let totalInvoice = 0;
    let wdTotalInvoice = 0;
    for(let item in this.escalationMatrix_array){
      console.log(this.escalationMatrix_array[item])
      totalInvoice +=  (!this.showApprovedFunc || this.escalationMatrix_array[item]?.isApproved != 0)?  parseFloat(this.escalationMatrix_array[item].jobtotal) : 0;
      wdTotalInvoice +=  (!this.showApprovedFunc || this.escalationMatrix_array[item]?.isApproved != 0) ?  parseFloat(this.escalationMatrix_array[item].jobWdTotal) : 0;
    }

    this.totalInvoice = totalInvoice;
    this.totalInvoiceShowOnly = Math.abs(totalInvoice).toFixed(2);
    this.apiUrl.totalPayInvoice = this.totalInvoiceShowOnly;
    this.wdTotalInvoice = Math.abs(wdTotalInvoice).toFixed(2);
    this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
    this.totalInvoice2 = true;

    console.log(totalInvoice);

    setTimeout(() => {
      this.checkUpdateArray();
      console.log(this.escalationMatrix_array);
      let data = {
        estimationArray: this.escalationMatrix_array,
        estimationTotal: this.totalInvoiceShowOnly,
        wdestimationTotal: this.wdTotalInvoice
      };
      if(this.viewType == 'estimate') {
        this.roData.estimationData = data;
        this.roData.estimationDataJsonArr = [data];
      } else {
        this.roData.invoiceData = data;
        this.roData.invoiceDataJsonArr = [data];
      }
      this.roestimationActionEmit.emit(data);
      this.estimationReferenceEmit.emit(this);
    }, 300);
  }

  isNumberKey(key,value,columnName){
    var keycode = (key.which) ? key.which : key.keyCode;
    console.log(keycode);
    console.log(value.length)
    console.log(columnName)
    if(value.length==0 && (columnName == 'jobprice')){
      if (keycode != 45 && keycode != 46 && keycode > 31
        && (keycode < 48 || keycode > 57))
         return false;
    }
    else{
      if (keycode != 46 && keycode > 31
        && (keycode < 48 || keycode > 57))
         return false;
    }
  }

  inputChange(event, productsLis, hId, colName,index='') {
    let value = event.target.value;
    console.log(value);
    console.log(productsLis);
    console.log(hId);
    console.log(colName);
    console.log(index);

    if(colName=='jobprice'){
      /*this.productsList[index].jobprice =  value;
      this.productsList[index].jobpriceShowOnly =  Math.abs(value).toFixed(2);*/

      if(value != '' && value != '-' && value != 0){
        this.productsList[index].jobprice =  value;
        let jobpriceVal = value;
        let jobpriceValChange = Number(jobpriceVal).toFixed(2);
        this.productsList[index].jobpriceShowStr =  jobpriceValChange;
        this.productsList[index].jobpriceShowOnly =  (Math.abs(value)).toFixed(2);
      }
      else{
        this.productsList[index].jobprice =  value;
        this.productsList[index].jobpriceShowStr =  this.productsList[index].jobprice;
        this.productsList[index].jobpriceShowOnly =  this.productsList[index].jobprice;
      }
    }
    if(colName=='jobqty'){
      //this.productsList[index].jobqty =  value;
      if(value != '' && value != 0){
        this.productsList[index].jobqty =  value;
        let jobqtyVal = value;
        let jobqtyChange = Number(jobqtyVal).toFixed(2);
        this.productsList[index].jobqtyShowStr = jobqtyChange;
      }
      else{
        this.productsList[index].jobqty =  value;
        this.productsList[index].jobqtyShowStr =  this.productsList[index].jobqty;
      }
    }

    this.productsList[index].jobtotal = this.productsList[index].jobqty * this.productsList[index].jobprice;
    this.productsList[index].jobtotalShowStr = Number( this.productsList[index].jobtotal).toFixed(2);
    this.productsList[index].jobtotalShowOnly = Math.abs(this.productsList[index].jobtotal).toFixed(2);
    this.setupDiscount(this.productsList[index], index);

    console.log(this.escalationMatrix_array);
    if(this.escalationMatrix_array.length>0)
    {
      for (let wsd in this.escalationMatrix_array)
      {
        let studentObj =  this.escalationMatrix_array.find(t=>t.id==productsLis.id);
        if(studentObj)
        {

          if(colName=='jobqty')
          {
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobId = this.productsList[index].jobId;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).qbId = this.productsList[index].qbId;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobqty = this.productsList[index].jobqtyShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotal = this.productsList[index].jobtotalShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowStr = this.productsList[index].jobtotalShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowOnly = this.productsList[index].jobtotalShowOnly;
          }
          if(colName=='jobprice')
          {
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobprice = this.productsList[index].jobpriceShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobpriceShowOnly = this.productsList[index].jobpriceShowOnly;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotal = this.productsList[index].jobtotalShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowStr = this.productsList[index].jobtotalShowStr;
            this.escalationMatrix_array.find(item => item.id == productsLis.id).jobtotalShowOnly = this.productsList[index].jobtotalShowOnly;
          }
          this.escalationMatrix_array.find(item => item.id == productsLis.id).jobWdTotal = this.productsList[index].jobWdTotal;
          this.escalationMatrix_array.find(item => item.id == productsLis.id).jobId = this.productsList[index].jobId;
          this.escalationMatrix_array.find(item => item.id == productsLis.id).qbId = this.productsList[index].qbId;
          this.escalationMatrix_array.find(item => item.id == productsLis.id).jobNotes = this.productsList[index].jobNotes;
          this.escalationMatrix_array.find(item => item.id == productsLis.id).jobMedia = this.productsList[index].jobMedia;
          this.escalationMatrix_array.find(item => item.id == productsLis.id).jobNotesEditFlag = this.productsList[index].jobNotesEditFlag;
        } else {
          let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;
          let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
          let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index].jobDiscount;
          this.setupDiscount(this.productsList[index], index);
          let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
          let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
          let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;
          if(colName=='jobqty'){
            this.escalationMatrix_array.push({
              id:productsLis.id,
              jobId,
              qbId,
              isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
              jobqty:this.productsList[index].jobqtyShowStr,
              jobtotal:this.productsList[index].jobtotalShowStr,
              jobtotalShowStr:this.productsList[index].jobtotalShowStr,
              jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
              jobDiscount,
              jobWdTotal:this.productsList[index].jobWdTotal,
              jobNotes,
              jobMedia,
              jobNotesEditFlag,
            });
          }
          if(colName=='jobprice'){
            this.escalationMatrix_array.push({
              id:productsLis.id,
              jobId,
              qbId,
              isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
              jobprice:this.productsList[index].jobpriceShowStr,
              jobpriceShowOnly:this.productsList[index].jobpriceShowOnly,
              jobtotal:this.productsList[index].jobtotalShowStr,
              jobtotalShowStr:this.productsList[index].jobtotalShowStr,
              jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
              jobDiscount,
              jobWdTotal:this.productsList[index].jobWdTotal,
              jobNotes,
              jobMedia,
              jobNotesEditFlag,
            });
          }
        }

      }
    }
    else
    {
      let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : this.productsList[index].jobDiscount;
      this.setupDiscount(this.productsList[index], index);
      let jobId = (this.productsList[index].jobId && this.productsList[index].jobId != undefined) ? this.productsList[index].jobId : 0;
      let qbId = (this.productsList[index].qbId && this.productsList[index].qbId != undefined) ? this.productsList[index].qbId : 0;
      let jobNotes = (this.productsList[index].jobNotes && this.productsList[index].jobNotes != undefined) ? this.productsList[index].jobNotes : '';
      let jobMedia = (this.productsList[index].jobMedia && this.productsList[index].jobMedia != undefined) ? this.productsList[index].jobMedia : [];
      let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0) ? true : false;
      if(colName=='jobqty'){
        this.escalationMatrix_array.push({
          id:productsLis.id,
          jobId,
          qbId,
          isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
          jobqty:this.productsList[index].jobqtyShowStr,
          jobtotal:this.productsList[index].jobtotalShowStr,
          jobtotalShowStr:this.productsList[index].jobtotalShowStr,
          jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
          jobDiscount,
          jobWdTotal:this.productsList[index].jobWdTotal,
          jobNotes,
          jobMedia,
          jobNotesEditFlag,
        });
      }
      if(colName=='jobprice'){
        this.escalationMatrix_array.push({
            id:productsLis.id,
            jobId,
            qbId,
            isApproved:this.productsList[index]?.isApproved != 0 ? 1 : 0,
            jobprice:this.productsList[index].jobpriceShowStr,
            jobpriceShowOnly:this.productsList[index].jobpriceShowOnly,
            jobtotal:this.productsList[index].jobtotalShowStr,
            jobtotalShowStr:this.productsList[index].jobtotalShowStr,
            jobtotalShowOnly:this.productsList[index].jobtotalShowOnly,
            jobDiscount,
            jobWdTotal:this.productsList[index].jobWdTotal,
            jobNotes,
            jobMedia,
            jobNotesEditFlag,
          });
        }
    }
    console.log(this.escalationMatrix_array);


    if(this.escalationMatrix_array.length>0)
    {
      for (let wsd in this.escalationMatrix_array)
      {
        if(this.repairOrderList.length>0)
        {
          for (let swsd in this.repairOrderList)
          {
            if(this.escalationMatrix_array[wsd].jobcode == this.repairOrderList[swsd].jobcode){
              console.log(this.escalationMatrix_array[wsd].jobprice);
              console.log(this.repairOrderList[swsd].jobprice);
              if(this.escalationMatrix_array[wsd].jobprice != this.repairOrderList[swsd].jobprice){
                this.escalationMatrix_array[wsd].jobpriceOverwrite = '1';
              }
            }
          }
        }

      }
    }
    this.calculateAmt();
  }

  jobNotesChange(index, event) {
    let jobNotes = event.target.value;
    this.productsList[index].jobNotes = jobNotes;
    if(this.repairOrderList) {
      this.repairOrderList[index].jobNotes = jobNotes;
    }
    if(this.escalationMatrix_array) {
      this.escalationMatrix_array[index].jobNotes = jobNotes;
    }
    let emitData = {
      estimationArray: this.escalationMatrix_array,
      estimationTotal: this.totalInvoice,
      wdestimationTotal: this.wdTotalInvoice
    };
    if(this.viewType == 'estimate') {
      this.roData.estimationData = emitData;
      this.roData.estimationDataJsonArr = [emitData];
    } else {
      this.roData.invoiceData = emitData;
      this.roData.invoiceDataJsonArr = [emitData];
    }
    this.roestimationActionEmit.emit(emitData);
    this.estimationReferenceEmit.emit(this);
  }


  setupDiscount(item, index:any = -1) {
    console.log(item)
    let discount = (this.customerDiscount > 0) ? this.customerDiscount : item.jobDiscount;
    let total = item.jobtotal;
    let wdPrice:any = total*(discount/100);
    wdPrice = total-wdPrice;
    wdPrice = (Math.abs(wdPrice)).toFixed(2);
    console.log(wdPrice)
    item.jobWdTotal = wdPrice;
    if(index >= 0) {
      this.productsList[index].jobWdTotal = wdPrice;
    } else {
      return wdPrice;
    }
  }

  setupDiscountTotal() {
    let wdTotalInvoice:any;
    console.log(this.customerDiscount, this.totalInvoiceShowOnly)
    if(this.customerDiscount > 0) {
      let discount = this.customerDiscount;
      let total = this.totalInvoiceShowOnly;
      wdTotalInvoice = total*(discount/100);
      wdTotalInvoice = total-wdTotalInvoice;
      wdTotalInvoice = (Math.abs(wdTotalInvoice)).toFixed(2);
    } else {
      wdTotalInvoice = (Math.abs(this.wdTotalInvoice)).toFixed(2);
    }
    this.wdTotalInvoice = wdTotalInvoice;
    this.apiUrl.wdTotalPayInvoice = this.wdTotalInvoice;
    return this.wdTotalInvoice;
  }

  attachmentPopup(estIndex,type) {
    let postId = this.roData.id;
    let fitem = [];
    let mitem = [];
    let eitem = [];
    let ditem = [];
    let obj = {};
    this.postApiData = {
      action: 'new',
      access: 'instant-est-job',
      pageAccess: 'instant-est-job',
      apiKey: Constant.ApiKey,
      domainId: this.domainId,
      countryId: '',
      userId: this.userId,
      dataId: postId,
      threadId: '',
      postId: 0,
      isEstJob: 1,
      contentType: this.contentType,
      displayOrder: this.displayOrder,
      roPushApiFlag: false,
      shopId: 0,
      assignTech: [],
      uploadedItems: [],
      attachments: [],
      attachmentItems: [],
      updatedAttachments: [],
      deletedFileIds: [],
      removeFileIds: [],
      pushData: obj
    };
    mitem = [];
    eitem = [];
    ditem = [];
    const modalRef = this.modalService.open(MediaUploadComponent, this.mediaConfig);
    modalRef.componentInstance.access = 'est-upload';
    modalRef.componentInstance.instantUpload = true;
    modalRef.componentInstance.fileAttachmentEnable = true;
    modalRef.componentInstance.mediaAttachments = true;
    modalRef.componentInstance.apiData = this.postApiData;
    modalRef.componentInstance.uploadedItems = fitem;
    modalRef.componentInstance.presetAttchmentItems = mitem;
    modalRef.componentInstance.updatedAttachments = eitem;
    modalRef.componentInstance.deletedFileIds = ditem;
    modalRef.componentInstance.uploadAttachmentAction.subscribe((receivedService) => {
      console.log(receivedService)
      let action = receivedService.action;
      if(action == 'save') {
        let uploadedItems = receivedService.items;
        uploadedItems.forEach(uitem => {
          let mediaId = uitem.mediaId;
          let mindex = this.productsList[estIndex].jobMedia.findIndex(option => parseInt(option) == parseInt(mediaId))
          if(mindex < 0) {
            this.productsList[estIndex].jobMedia.push(mediaId);
            this.escalationMatrix_array[estIndex].jobMedia.push(mediaId);
            this.estJobUploadContents[estIndex].uploadContents.push(uitem);
          }
        });
        let unique = [...new Set(this.productsList[estIndex].jobMedia)];
        this.productsList[estIndex].jobMedia = unique;
        this.escalationMatrix_array[estIndex].jobMedia = unique;
        let emitData = {
          estimationArray: this.escalationMatrix_array,
          estimationTotal: this.totalInvoice,
          wdestimationTotal: this.wdTotalInvoice
        };
        if(this.viewType == 'estimate') {
          this.roData.estimationData = emitData;
          this.roData.estimationDataJsonArr = [emitData];
          this.roData.estJobUploadContentsJsonArr = this.estJobUploadContents;
        } else {
          this.roData.invoiceData = emitData;
          this.roData.invoiceDataJsonArr = [emitData];
          this.roData.invoiceJobUploadContentsJsonArr = this.estJobUploadContents;
        }
        this.roestimationActionEmit.emit(emitData);
        this.estimationReferenceEmit.emit(this);
        console.log(emitData, this.productsList[estIndex])
        this.attachmentLoading = true;
        setTimeout(() => {
          this.attachmentLoading = false;
          //this.setupRowHeight(estIndex);
        }, 200);
      }
      setTimeout(() => {
        modalRef.dismiss('Cross click');
      }, 110);
    });
  }

  attachmentAction(index, data) {
    let mediaId = parseInt(data['mediaId']);
    let pmedia:any = this.productsList[index].jobMedia;
    let pmIndex = pmedia.findIndex(option => parseInt(option) == mediaId);
    if(pmIndex >= 0) {
      pmedia.splice(pmIndex, 1);
    }
    let rmedia = this.repairOrderList[index].jobMedia;
    let rmIndex = rmedia.findIndex(option => parseInt(option) == mediaId);
    if(rmIndex >= 0) {
      rmedia.splice(rmIndex, 1);
    }
    let escMedia = this.escalationMatrix_array[index].jobMedia;
    let emIndex = pmedia.findIndex(option => parseInt(option) == mediaId);
    if(emIndex >= 0) {
      escMedia.splice(emIndex, 1);
    }
    let jmIndex = this.estJobUploadContents[index].uploadContents.findIndex(option => parseInt(option.mediaId) == mediaId);
    if(jmIndex >= 0) {
      this.estJobUploadContents[index].uploadContents.splice(jmIndex, 1);
    }
    let emitData = {
      estimationArray: this.escalationMatrix_array,
      estimationTotal: this.totalInvoice,
      wdestimationTotal: this.wdTotalInvoice
    };
    if(this.viewType == 'estimate') {
      this.roData.estimationData = emitData;
      this.roData.estimationDataJsonArr = [emitData];
      this.roData.estJobUploadContentsJsonArr = this.estJobUploadContents;
    } else {
      this.roData.invoiceData = emitData;
      this.roData.invoiceDataJsonArr = [emitData];
      this.roData.invoiceJobUploadContentsJsonArr = this.estJobUploadContents;
    }
    this.roestimationActionEmit.emit(emitData);
    this.estimationReferenceEmit.emit(this);
    //this.setupRowHeight(index);
  }

  notesToggle(index) {
    console.log(index, this.estJobUploadContents)
    this.productsList.forEach((item, pi) => {
      if(index == pi) {
        item.jobNotesEditFlag = !item.jobNotesEditFlag;
        let action = (item.jobNotesEditFlag) ? '' : 'remove';
        setTimeout(() => {
          //this.setupRowHeight(index, action);
        }, 1);
      }/*  else {
        item.jobNotesEditFlag = false;
      } */
    });
  }

  deleteEstNotesMedia(index) {
    const modalRef = this.modalService.open(ConfirmationComponent, { backdrop: 'static', keyboard: false, centered: true });
      modalRef.componentInstance.access = 'est-job-notes';
      modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
        modalRef.dismiss('Cross click');
        if(receivedService) {
          this.productsList[index].jobNotes = '';
          this.productsList[index].jobMedia = [];
          this.productsList[index].jobNotesEditFlag = false;
          this.estJobUploadContents[index].uploadContents = [];
          /* let emitData = {
            estimationArray: this.escalationMatrix_array,
            estimationTotal: this.totalInvoice,
            wdestimationTotal: this.wdTotalInvoice
          };
          this.roestimationActionEmit.emit(emitData);
          this.estimationReferenceEmit.emit(this);
          console.log(this.productsList[index]) */
          this.attachmentLoading = true;
          setTimeout(() => {
            this.attachmentLoading = false;
            //this.setupRowHeight(index);
          }, 100);
        }
      });
  }

  setupRowHeight(index: any = '', action = '') {
    let rowElements:any, rowElementName = 'est-job-rows';
    if(index == '') {
      rowElements = document.getElementsByClassName(rowElementName);
    } else {
      let element =  `${rowElementName}-${index}`;
      rowElements = document.getElementsByClassName(element);
    }
    console.log(index, rowElements)
    Array.prototype.forEach.call(rowElements, function(el) {
      if(action == 'remove') {
        el.removeAttribute('style');
      } else {
        let tdCol = el.getElementsByClassName('ro-ta-col-1');
        let actionCol = el.getElementsByClassName('job-action-row');
        let height1 = (tdCol && tdCol.length > 0) ? tdCol[0].offsetHeight : 0;
        let height2 = (actionCol && actionCol.length > 0) ? actionCol[0].offsetHeight : 0;
        console.log(index, height1, height2);
        let rowHeight = (height1 + height2)+10;
        if(height2 > 0) {
          el.style.height = `${rowHeight}px`;
        }
      }
    });
  }

  setupJobViewHeight(index: any = '', action = '') {
    let rowElements:any, rowElementName = 'est-job-view-rows';
    if(index == '') {
      rowElements = document.getElementsByClassName(rowElementName);
    } else {
      let element =  `${rowElementName}-${index}`;
      rowElements = document.getElementsByClassName(element);
    }
    console.log(index, rowElements)
    Array.prototype.forEach.call(rowElements, function(el) {
      if(action == 'remove') {
        el.removeAttribute('style');
      } else {
        let tdCol = el.getElementsByClassName('ro-ta-col-1');
        let actionCol = el.getElementsByClassName('job-view-row');
        let height1 = (tdCol && tdCol.length > 0) ? tdCol[0].offsetHeight : 0;
        let height2 = (actionCol && actionCol.length > 0) ? actionCol[0].offsetHeight : 0;
        console.log(index, height1, height2);
        let rowHeight = (height1 + height2)+10;
        if(height2 > 0) {
          el.style.height = `${rowHeight}px`;
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  autoGenerateEstimates() {
    this.loadingAutoGenEstimates = true;
    console.log(this.roData);
    const apiFormData = {
      apiKey: this.apiKey,
      domainId: this.domainId,
      userId: this.userId,
      reportId: this.roData.adasReportIdInt
    };
    this.allDataApiService.getEstimateByReport(apiFormData).subscribe((response) => {
      console.log(response);
      this.loadingAutoGenEstimates = false;
      if (response.status == 'Success') {
        this.autoGeneratedJobs = response.data;
        const existingItemsCount = this.productsList?.length || 0;
        this.autoGeneratedJobs.forEach((job, index) => {
          let newIndex = index + existingItemsCount;
          let qbId = (job?.qbId && job?.qbId != undefined) ? job?.qbId : 0;
          let item = {
            id: newIndex,
            jobId: job.id,
            qbId,
            newmatrix: newIndex,            
            jobcode: job.jobCode,
            jobtitle: job.title,
            jobdesc: job.description,
            jobprice: job.unitPrice,
            jobDiscount: job.discount,
            jobWdTotal: this.setupDiscount(job),
            jobpriceOverwrite: '0',
            jobqty: 1.00,
            jobqtyShowStr: '1.00',
            jobtotal: (job.jobqty) * (job.unitPrice), jobNotes: '', jobMedia: [], jobEditFlag: true
          };
          this.productsList.push(item);
          this.onChangeOption(job.title, item, 3, 'jobtitle', newIndex)
        });
        this.itemEmpty = false;
        this.loginToAllData = false;
      }
      if (response.status == 'Failure')  {
        this.loginToAllData = true;
      }
    });
  }

  syncAllDataAccessToken() {
    const stateUrl = new URL(window.location.href).origin + new URL(window.location.href).pathname;
    window.location.href = `${Constant.collabticV3PreProdApiUrl}/all-data/authorize?userId=${localStorage.getItem('userId')}&state=${stateUrl}`;
  }

  // get jobTotal(): number {
  //   return this.detailRepairOrderList?.reduce((sum, item) => {
  //     return sum + (item?.isApproved ? item.jobtotalShowOnly : 0);
  //   }, 0) ?? 0;
  // }

  approveJob(approve: number, index: number) {
    this.detailRepairOrderList[index].isApproved = approve;

    let total = 0, wdTotal = 0;
    this.detailRepairOrderList.forEach((item, index)=> {
      total += item.isApproved != 0 ? parseFloat(item.jobtotal) : 0;
      wdTotal += item.isApproved != 0 ? parseFloat(item.jobWdTotal) : 0;
    });

    this.totalInvoiceView = total;
    this.totalInvoiceViewOnly = total.toString();
    this.wdTotalInvoice = wdTotal;

    let formData = new FormData();
    formData.append('apiKey', this.apiKey);
    formData.append('userId', this.userId);
    formData.append('platformId', '3');
    formData.append('domainId', this.domainId);
    formData.append('woId', this.roData?.roIdInt);
    formData.append('approve', approve.toString());
    formData.append('index', index.toString());
    formData.append('total', total.toFixed(2));
    formData.append('wdTotal', wdTotal.toFixed(2));

    this.repairOrderApi.updateEstimateApprove(formData).subscribe((res)=> {
      if(res.status == 'Success') {
        this.roEstimationApproveActionEmit.emit(approve);
        this.messageService.add({ severity: 'success', summary: 'Job Code #'+this.detailRepairOrderList[index].jobcode+' has been ' + (approve ? 'approved' : 'declined'), closable: false, life: 2000 });
      }
    })
  }

  approveJobAdmin(approve: number, index: number) {
    this.productsList[index].isApproved = approve;

    let total = 0, wdTotal = 0;
    this.productsList.forEach((item, index)=> {
      total += item.isApproved != 0 ? parseFloat(item.jobtotal) : 0;
      wdTotal += item.isApproved != 0 ? parseFloat(item.jobWdTotal) : 0;
    });

    this.totalInvoice = total;
    this.totalInvoiceShowOnly = total.toString();
    this.wdTotalInvoice = wdTotal;

    let formData = new FormData();
    formData.append('apiKey', this.apiKey);
    formData.append('userId', this.userId);
    formData.append('platformId', '3');
    formData.append('domainId', this.domainId);
    formData.append('woId', this.roData?.roIdInt);
    formData.append('approve', approve.toString());
    formData.append('index', index.toString());
    formData.append('total', total.toFixed(2));
    formData.append('wdTotal', wdTotal.toFixed(2));

    this.repairOrderApi.updateEstimateApprove(formData).subscribe((res)=> {
      if(res.status == 'Success') {
        this.roEstimationApproveActionEmit.emit(approve);
        this.messageService.add({ severity: 'success', summary: 'Job Code #'+this.productsList[index].jobcode+' has been ' + (approve ? 'approved' : 'declined'), closable: false, life: 2000 });
      }
    })
  }

  onChangeSelection(type: string = 'jobCode', itemData?: any, idx?: any) {
    console.log("onChangeSelection: ", { type });
    const apiData = {
      apiKey: Constant.ApiKey,
        domainId: this.domainId,
        userId: this.userId,
        countryId: this.countryId,
        networkId: this.user.networkId,
        type: 1,
        offset: 0,
        limit: 100,
    };
              
      const modalRef = this.modalService.open(SelectJobsListComponent, {
          backdrop: "static",
          keyboard: false,
          centered: true,
          size: "xl",
          windowClass: 'jobs-popup-custom-model'
      });

      const iHeight = window.innerHeight
      modalRef.componentInstance.type = 'jobs-list';
      modalRef.componentInstance.apiData = apiData;
      modalRef.componentInstance.height = iHeight - 130;
      modalRef.componentInstance.checkboxColor = "active-green";
      modalRef.componentInstance.selectType = "multiple"
      modalRef.componentInstance.title = "Jobs List"

      let accessLevels = this.authenticationService.checkAccessItems;
      console.log("Access Levels: ", accessLevels);
    
      if(this.productsList?.length){
        modalRef.componentInstance.defaultSelected = this.productsList?.filter(item => item?.jobId) || [];
      }  
                
      modalRef.componentInstance.selectedItems.subscribe((receivedService) => {
        console.log("Received ", receivedService);

        if(Array.isArray(receivedService)){
          console.log("Data => ", { productsList: this.productsList, receivedService });
          console.log("Data => ", { escalationMatrix_array: this.escalationMatrix_array });

          // Step 1: Remove items from productsList that don't exist in receivedService
          const receivedServiceIds = receivedService.map(service => service.id);
          
          // Filter out items that are no longer in receivedService
          const itemsToRemove = this.productsList.filter(product => 
            !receivedServiceIds.includes(product.jobId)
          );
          console.log("itemsToRemove: ", itemsToRemove);
          
          
          // Remove corresponding items from escalationMatrix_array and estJobUploadContents
          if(itemsToRemove?.length){
            itemsToRemove.forEach(item => {
              const productIndex = this.productsList.findIndex(p => p.id == item.id);
              if (productIndex !== -1) {
                // Remove from escalationMatrix_array
                const escalationIndex = this.escalationMatrix_array.findIndex(e => e.id == item.id);
                if (escalationIndex !== -1) {
                  this.escalationMatrix_array.splice(escalationIndex, 1);
                }
                
                // Remove from estJobUploadContents (assuming same index)
                if (productIndex < this.estJobUploadContents.length) {
                  console.log("estJobUploadContents: ", this.estJobUploadContents);
                  this.estJobUploadContents.splice(productIndex, 1);

                  this.attachmentLoading = true;
                  setTimeout(() => {
                    this.attachmentLoading = false;
                    //this.setupRowHeight(index);
                  }, 100);
                }
              }
            });
          }
          
          // Remove items from productsList
          this.productsList = this.productsList.filter(product => 
            receivedServiceIds.includes(product.jobId)
          );

          // Step 2: Process each item in receivedService
          receivedService.forEach((receivedData, serviceIndex) => {
            // Check if item already exists in productsList (match by jobId)
            let existingProductIndex = this.productsList.findIndex(product => 
              product.jobId == receivedData.id
            );
            
            if (existingProductIndex === -1) {
              // Step 3: Add new item if it doesn't exist
              let idVal = 1;
              if(this.productsList && this.productsList.length > 0){
                const existingIds = this.productsList.map(p => p.id);
                idVal = Math.max(...existingIds) + 1;
              }
              
              // let jobDiscount = (this.customerDiscount > 0) ? this.customerDiscount.toString() : '0';
              let jobDiscount = (this.customerDiscount > 0) ? 
                this.customerDiscount.toString() : 
                parseFloat(receivedData?.discountPrice || receivedData?.jobDiscount || receivedData?.discount || 0);
              
              // Add to estJobUploadContents array
              this.estJobUploadContents.push({uploadContents: []});
              
              // Create new product item
              const newProduct = {
                id: idVal,
                jobId: receivedData.id,
                qbId: receivedData.qbId,
                isApproved: 1,
                newmatrix: idVal,
                jobcode: receivedData.jobCode,
                jobtitle: receivedData.jobtitle,
                jobdesc: receivedData.jobdesc,
                jobDuration: receivedData.jobDuration,
                jobprice: receivedData.unitPrice == '' ? '0' : parseFloat(receivedData.unitPrice).toString(),
                jobDiscount,
                jobWdTotal: '0.0',
                jobpriceOverwrite: '0',
                jobqty: '1.00',
                jobqtyShowStr: '1.00',
                jobtotal: '',
                jobNotes: '',
                jobMedia: [],
                jobEditFlag: true
              };
              
              this.productsList.push(newProduct);
              existingProductIndex = this.productsList.length - 1;
            }
            
            // Step 4: Update the product (whether existing or newly created)
            if (existingProductIndex !== -1 && existingProductIndex < this.productsList.length) {
              const currentProduct = this.productsList[existingProductIndex];
              let jobDiscount = (this.customerDiscount > 0) ? 
                this.customerDiscount.toString() : 
                parseFloat(currentProduct?.discountPrice || currentProduct?.jobDiscount || currentProduct?.discount || 0);
              
              console.log("currentProduct before: ", currentProduct);
              // Update product properties
              currentProduct.jobId = receivedData.id;
              currentProduct.qbId = receivedData.qbId;
              currentProduct.jobcode = receivedData.jobCode;
              currentProduct.jobtitle = receivedData.jobtitle;
              currentProduct.jobdesc = receivedData.jobdesc;
              currentProduct.jobDuration = receivedData.jobDuration;
              currentProduct.jobprice = receivedData.unitPrice == ''  ? 0 : parseFloat(receivedData?.unitPrice || receivedData?.jobprice || "0");
              currentProduct.jobqty = parseFloat(currentProduct.jobqty || '1');
              currentProduct.jobtotal = currentProduct.jobqty * currentProduct.jobprice;
              currentProduct.jobDiscount = jobDiscount;
              currentProduct.jobWdTotal = this.setupDiscount(currentProduct);
              currentProduct.isApproved = receivedData.isApproved ?? 1;
              currentProduct.jobNotes = receivedData.jobNotes || '';
              currentProduct.jobMedia = receivedData.jobMedia.length ? receivedData.jobMedia : [];
              currentProduct.jobNotesEditFlag = (receivedData.jobNotes != '' || receivedData.jobMedia.length > 0);

              // Update display strings
              currentProduct.jobqtyShowStr = Number(currentProduct.jobqty).toFixed(2);
              currentProduct.jobpriceShowStr = Number(currentProduct.jobprice).toFixed(2);
              currentProduct.jobpriceShowOnly = Math.abs(parseFloat(currentProduct.jobprice)).toFixed(2);
              currentProduct.jobtotalShowStr = Number(currentProduct.jobtotal).toFixed(2);
              currentProduct.jobtotalShowOnly = Math.abs(parseFloat(currentProduct.jobtotal)).toFixed(2);
              currentProduct.jobWdTotal = Math.abs(parseFloat(currentProduct.jobWdTotal)).toFixed(2);

              console.log("currentProduct: ", currentProduct);
              

              // Step 5: Update or create escalationMatrix_array entry
              if(this.escalationMatrix_array?.length) {
                let existingEscalationIndex = this.escalationMatrix_array.findIndex(t => t.id == currentProduct.id);
                
                if(existingEscalationIndex !== -1) {
                  // Update existing escalation matrix item
                  let targetItem = this.escalationMatrix_array[existingEscalationIndex];
                  this.updateEscalationMatrixItem(targetItem, currentProduct, jobDiscount);
                } else {
                  // Create new escalation matrix item
                  this.createEscalationMatrixItem(currentProduct, jobDiscount);
                }
              } else {
                // Initialize escalationMatrix_array and create first item
                this.escalationMatrix_array = [];
                this.createEscalationMatrixItem(currentProduct, jobDiscount);
              }
            }
          });

          console.log("ProductsList Synchronized => ", { productsList: this.productsList });
          console.log("EscalationMatrix Synchronized => ", { escalationMatrix_array: this.escalationMatrix_array });
          console.log("EscalationMatrix Synchronized => ", { estJobUploadContents: this.estJobUploadContents });
          
          setTimeout(() => {
            this.calculateAmt();
          }, 100);
        }
    })
  }

  // Helper method to update escalation matrix item
  updateEscalationMatrixItem(targetItem, product, jobDiscount) {
    this.setupDiscount(product);
    
    targetItem.jobId = product.jobId;
    targetItem.qbId = product.qbId;
    targetItem.jobcode = product.jobcode;
    targetItem.jobtitle = product.jobtitle;
    targetItem.jobdesc = product.jobdesc;
    targetItem.jobDuration = product.jobDuration;
    targetItem.jobprice = product.jobpriceShowStr;
    targetItem.jobpriceShowOnly = product.jobpriceShowOnly;
    targetItem.jobqty = product.jobqtyShowStr;
    targetItem.jobtotal = product.jobtotalShowStr;
    targetItem.jobtotalShowStr = product.jobtotalShowStr;
    targetItem.jobtotalShowOnly = product.jobtotalShowOnly;
    targetItem.jobDiscount = jobDiscount;
    targetItem.jobWdTotal = product.jobWdTotal;
    targetItem.jobNotes = product.jobNotes;
    targetItem.jobMedia = product.jobMedia;
    targetItem.jobNotesEditFlag = product.jobNotesEditFlag;
  }

  // Helper method to create new escalation matrix item
  createEscalationMatrixItem(product, jobDiscount) {
    this.setupDiscount(product);
    
    let jobId = product.jobId || 0;
    let qbId = product.qbId || 0;
    let jobNotes = product.jobNotes || '';
    let jobMedia = product.jobMedia || [];
    let jobNotesEditFlag = (jobNotes != '' || jobMedia.length > 0);
    
    this.escalationMatrix_array.push({
      id: product.id,
      jobId,
      qbId,
      isApproved: product?.isApproved != 0 ? 1 : 0,
      jobcode: product.jobcode,
      jobtitle: product.jobtitle,
      jobdesc: product.jobdesc,
      jobDuration: product.jobDuration,
      jobprice: product.jobpriceShowStr,
      jobpriceShowOnly: Math.abs(product.jobprice).toFixed(2),
      jobpriceOverwrite: product.jobpriceOverwrite,
      jobDiscount,
      jobWdTotal: product.jobWdTotal,
      jobqty: product.jobqtyShowStr,
      jobtotal: product.jobtotalShowStr,
      jobtotalShowStr: product.jobtotalShowStr,
      jobtotalShowOnly: product.jobtotalShowOnly,
      jobNotes,
      jobMedia,
      jobNotesEditFlag,
    });
  }
}

